<template>
  <div
    class="payment-init-fallback"
    data-testid="payment-init-fallback"
  >
    <template v-if="status === 'failed'">
      <nuxt-icon
        name="attention"
        class="payment-init-fallback__icon"
      />
      <p
        class="payment-init-fallback__message"
        v-html="$t(offline ? 'no_internet_page_text_subtitle' : message)"
      />
      <base-button
        type="black"
        data-testid="payment-init-retry"
        @click="emit('retry')"
      >
        {{ $t(action) }}
      </base-button>
    </template>
    <template v-else>
      <base-button
        class="payment-init-fallback__loader"
        is-loading
        type="black"
      />
      <p
        v-if="status === 'reconnecting'"
        class="payment-init-fallback__hint"
      >
        {{ $t('payment_init_reconnecting') }}
      </p>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { PaymentInitStatus } from '../types/paymentInit';

withDefaults(defineProps<{
  status: PaymentInitStatus
  offline?: boolean
  message?: string
  action?: string
}>(), {
  offline: false,
  message: 'payment_init_error_message',
  action: 'retry',
});

const emit = defineEmits<{ retry: [] }>();
</script>

<style lang="scss" scoped>
  .payment-init-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 0;
    text-align: center;

    &__icon {
      font-size: 24px;
      color: $red;
    }

    &__message {
      color: $red;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
    }

    &__loader {
      height: 57px;
      min-height: 57px;
      padding: 0;
      border-radius: 9px;
    }

    &__hint {
      color: $disclaimer-text;
      font-size: 14px;
      line-height: 21px;
    }
  }
</style>
